import { createSlice } from '@reduxjs/toolkit'
import createLazyLoadSlice from './createLazyLoadSlice';
import API_ENDPOINTS from '../../api/apiConfig';
import {getTestListData} from '@/core/utils/getTestListData';
import { TestItem } from '@/store/types/testItemTypes';

const resultRecommendationsSlice = createLazyLoadSlice<TestItem>('resultRecommendations', {});

// const specificReducers = {};

const combinedSlice = createSlice({
    name: 'resultRecommendations',
    initialState: resultRecommendationsSlice.getInitialState(),
    reducers: {
        ...resultRecommendationsSlice.caseReducers,
        // ...specificReducers,
    },
});

export const {
    incrementPage,
    fetchDataStart,
    setDataLoaded,
    setLastPage,
    fetchDataError
} = combinedSlice.actions;

export const getRecommendations = (testId: number) =>
    getTestListData(combinedSlice, `${API_ENDPOINTS.recommendations}${testId}?page=`);

export default combinedSlice.reducer;
export { combinedSlice as resultRecommendationsSlice };